import type { FaireProductEntity } from "../../entity_types/product";

export const p_wzpjqbtqnd: FaireProductEntity = {
  token: "p_wzpjqbtqnd",
  type: "product",
  name: "Oatmeal Cookie Creme Pie™ (V/GF)",
  brandToken: "b_4xhf67vcvr",
  brandName: "Out The Dough",
  imageUrl:
    "https://cdn.faire.com/fastly/61bb3155e930a3d2af9dd9e1d2a3cab3e28f2a407de52bf210c43c5cc6d759f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30d1e9105aa7c7d5b96370bb38be93c16e81f0584634ed5a6cceb7775ed57448.png",
  ],
  priceDollars: 4.97,
  description:
    "Oatmeal Creme Pie - Vegan Buttercreme Sandwiched Between Two Oatmeal Cookies. (Contains: Soy; DELICIOUSLY VEGAN & GLUTEN-FREE). Made in small batches in California's East Bay - from scratch since 2017. Made with heat-treated, pastuerized products - with zero preservatives, artificial dyes or additives. With a mission to create delectable cookie dough treats everyone can enjoy, you can treat yourself to something truly satisfying!",
  tags: [],
  msrpDollars: 8.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:40.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
